__turbopack_context__.v({
  "copied": "HeaderShare-module-scss-module__JOURbq__copied",
  "disabledMenuBtn": "HeaderShare-module-scss-module__JOURbq__disabledMenuBtn",
  "modalBody": "HeaderShare-module-scss-module__JOURbq__modalBody",
  "url": "HeaderShare-module-scss-module__JOURbq__url",
  "urlCopy": "HeaderShare-module-scss-module__JOURbq__urlCopy",
});
